// Debug utility to test Vietnamese YBT parameter translations
// Run this from browser console: debugVietnameseYBT()

import { getParameterDisplayName } from './parameterDisplayNames';
import { getParameterDisplayNameVi, hasVietnameseTranslation } from './parameterDisplayNamesVi';
import i18n from '../i18n';

export const debugVietnameseYBT = () => {
  console.log('🔍 DEBUGGING VIETNAMESE YBT PARAMETERS...\n');
  
  // YBT parameters that should appear in Vietnamese
  const ybtParameters = [
    'biometrics_balance_ybt_right_composite_reach',
    'biometrics_balance_ybt_left_composite_reach', 
    'biometrics_balance_ybt_composite_deviation',
    'biometrics_balance_ybt_anterior_deviation',
    'biometrics_balance_ybt_posteromedial_deviation',
    'biometrics_balance_ybt_posterolateral_deviation',
    'biometrics_balance_ybt_performance_ratio'
  ];

  console.log(`📋 Current i18n language: ${i18n.language}`);
  console.log(`📋 Testing ${ybtParameters.length} YBT parameters...\n`);

  ybtParameters.forEach((paramKey, index) => {
    console.log(`${index + 1}. Testing: ${paramKey}`);
    
    // Test Vietnamese translation existence
    try {
      const hasVi = hasVietnameseTranslation(paramKey);
      console.log(`   ✓ Has Vietnamese translation: ${hasVi}`);
      
      if (hasVi) {
        const viName = getParameterDisplayNameVi(paramKey);
        console.log(`   ✓ Vietnamese name: "${viName}"`);
      }
    } catch (error) {
      console.log(`   ✗ Vietnamese translation error: ${error.message}`);
    }
    
    // Test English display name
    try {
      const enName = getParameterDisplayName(paramKey, 'en');
      console.log(`   ✓ English name: "${enName}"`);
    } catch (error) {
      console.log(`   ✗ English name error: ${error.message}`);
    }
    
    // Test automatic language detection
    try {
      const autoName = getParameterDisplayName(paramKey);
      console.log(`   ✓ Auto-detected name: "${autoName}"`);
    } catch (error) {
      console.log(`   ✗ Auto-detected name error: ${error.message}`);
    }
    
    // Test forced Vietnamese
    try {
      const forcedViName = getParameterDisplayName(paramKey, 'vi');
      console.log(`   ✓ Forced Vietnamese name: "${forcedViName}"`);
    } catch (error) {
      console.log(`   ✗ Forced Vietnamese error: ${error.message}`);
    }
    
    console.log(''); // Empty line for readability
  });

  // Test if the issue is with the flowsheet data processing
  console.log('🔍 FLOWSHEET DATA ANALYSIS...\n');
  
  // Check if there's flowsheet data available
  if (window.location.href.includes('/patients/')) {
    console.log('📊 On patient flowsheet page - checking for YBT data...');
    
    // Try to access flowsheet data from the component state (if available)
    const flowsheetTables = document.querySelectorAll('[data-testid="flowsheet-table"], .ant-table-tbody');
    console.log(`Found ${flowsheetTables.length} potential flowsheet tables`);
    
    // Look for YBT-related text in the page
    const pageText = document.body.innerText;
    const ybtMatches = pageText.match(/YBT|Y Balance|Tầm với|Độ lệch|Tỷ lệ hiệu suất/gi) || [];
    console.log(`Found ${ybtMatches.length} YBT-related text matches on page:`, ybtMatches);
    
    // Check for Balance subcategory
    const balanceElements = document.querySelectorAll('*');
    let balanceFound = false;
    balanceElements.forEach(el => {
      if (el.textContent && (el.textContent.includes('Balance') || el.textContent.includes('Thăng bằng'))) {
        balanceFound = true;
      }
    });
    console.log(`Balance subcategory found on page: ${balanceFound}`);
    
  } else {
    console.log('⚠️  Not on a patient flowsheet page - navigate to a patient flowsheet to test data');
  }

  console.log('\n🎯 RECOMMENDATIONS:');
  console.log('1. Verify all Vietnamese translations are working');
  console.log('2. Check if YBT data exists in the database');
  console.log('3. Ensure biometric parameter mapping includes YBT parameters');
  console.log('4. Test with sample data if needed');
  
  return {
    language: i18n.language,
    parametersChecked: ybtParameters.length,
    message: 'Debug completed - check console for details'
  };
};

// Make it available globally for console use
if (typeof window !== 'undefined') {
  window.debugVietnameseYBT = debugVietnameseYBT;
}

// Instructions
console.log(`
🔧 VIETNAMESE YBT DEBUG UTILITY
==============================

To debug Vietnamese YBT parameter display issues:

1. Open browser console (F12) on Vietnamese flowsheet
2. Run: debugVietnameseYBT()
3. Check the detailed output for each parameter
4. Look for translation errors or missing data

This will test:
- Vietnamese translation existence
- Parameter display name retrieval
- Language detection
- Flowsheet data presence

Expected Vietnamese names:
- YBT Tầm với tổng hợp - Phải/Trái (Composite Reach)
- YBT Tỷ lệ hiệu suất (Performance Ratio)
- YBT Độ lệch tổng hợp (Composite Deviation)
- YBT Độ lệch trước/sau trong/sau ngoài (Individual Deviations)
`);
